import React, { FC } from 'react'
import styles from './DropDownElement.module.scss'

type DropDownElementProps = {
  value: string | number
  label: string
}

export const DropDownElement: FC<DropDownElementProps> = ({ value = '', label = '' }) => {
  return (
    <option value={value} className={styles.dropDownElement}>
      {label}
    </option>
  )
}

DropDownElement.displayName = 'DropDownElement'
